import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import PrintGeneratedPicklists from 'components/Sales/PrintGeneratedPicklists';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <PrintGeneratedPicklists />
      </SiteContent>
    </ContentLayout>
  );
};
